import React from "react";

const noSelector = () => ({});

const defaultOptions = {
  erase: false
};

export default function translateProps(
  translate = noSelector,
  options = defaultOptions
) {
  const originalProps = props => {
    if (options.erase) {
      return {};
    }

    return props;
  };

  return Component => (props, ...args) => (
    <Component {...originalProps(props)} {...translate(props, ...args)} />
  );
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/translateProps.jsx